import { createElementBlock as r, openBlock as t, createElementVNode as l } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 21 21"
};
function n(a, e) {
  return t(), r("svg", o, [...e[0] || (e[0] = [
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9.14 3.25a6.39 6.39 0 1 0 3.955 11.406l3.874 3.874a.75.75 0 0 0 1.061-1.06l-3.874-3.875A6.39 6.39 0 0 0 9.14 3.25m3.476 9.827A4.889 4.889 0 1 0 5.664 6.2a4.889 4.889 0 0 0 6.952 6.876Z"
    }, null, -1)
  ])]);
}
const d = { render: n };
export {
  d as default,
  n as render
};
